<template>
  <div v-click-outside="reset">
    <button
      class="btn btn-cancel double-optin-button"
      v-if="hasClicked"
      @click="onDelete"
    >{{ $t('ui.button.double_optin') }}</button>
    <i v-else class="icon yule-icon-trash action-icon delete-icon" @click="click" />
  </div>
</template>
<script>
import { EventBus } from "@/EventBus";
export default {
  data() {
    return {
      hasClicked: false
    };
  },
  // Allows double opt in for delete action.
  // Note that parent must reset this component if navigating away.
  //
  // beforeUpdate() {
  //   EventBus.$emit("doubleDeleteReset");
  // },
  mounted() {
    EventBus.$on("doubleDeleteReset", this.reset);
  },
  methods: {
    reset() {
      this.hasClicked = false;
    },
    click(event) {
      this.hasClicked = true;
      // Allows our v-click-outside to work
      event.stopPropagation();
    },
    onDelete() {
      this.$emit("delete");
      this.hasClicked = false;
    }
  }
};
</script>
<style lang="sass">
.double-optin-button
  user-select: none
  padding: 0 1.15rem !important
</style>



// WEBPACK FOOTER //
// DoubleOptInDelete.vue?0d284acc